/**
 * remarksCategoryApi.js
 * ---------------------
 * API client for Remarks Category Master (RemarksCategory) using createMasterApiClient.
 * Connects directly to FastAPI backend /remarks-category/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const remarksCategoryClient = createMasterApiClient('remarks-category');

export const listRemarksCategories = (params) => remarksCategoryClient.list(params);
export const getRemarksCategoryDetail = (id) => remarksCategoryClient.getById(id);
export const createRemarksCategory = (data) => remarksCategoryClient.create(data);
export const updateRemarksCategory = (id, data) => remarksCategoryClient.update(id, data);
export const archiveRemarksCategory = (id) => remarksCategoryClient.archive(id);
export const deleteRemarksCategory = (id) => remarksCategoryClient.remove(id);
export const getRemarksCategoryOptions = () => remarksCategoryClient.getDropdownOptions();
